import { Box, Button, Dialog, DialogContent, Typography, createStyles, makeStyles, } from '@material-ui/core';
import { DialogTitle } from '../ModalCommon';
import React from 'react';
import omit from 'lodash/omit';
const useStyles = makeStyles((theme) => createStyles({
    root: {
        margin: 0,
        padding: theme.spacing(3, 7, 4),
        display: 'flex',
        textAlign: 'center',
        alignItems: 'center',
        backgroundColor: 'white',
    },
    container: {
        overflowY: 'auto',
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    preview: {
        margin: theme.spacing(4, 2, 2, 2),
        pointerEvents: 'none',
        touchEvents: 'none',
        textAlign: 'left',
    },
    body: {
        maxWidth: '450px',
        width: '100%',
        margin: 'auto',
    },
}));
const ActionModal = ({ cancelAction, confirmAction, hideModal, title, children, negativeMessage, positiveMessage, actionMessage, header, ...rest }) => {
    const classes = useStyles();
    return (React.createElement(Dialog, Object.assign({ open: true }, rest, { classes: { container: classes.container }, PaperProps: { classes: { root: 'modal-can-overflow' } } }),
        React.createElement(DialogTitle, { onClose: hideModal }, title),
        React.createElement(DialogContent, { dividers: true, classes: omit(classes, ['container', 'actions', 'preview', 'body']) },
            React.createElement("div", { className: classes.body },
                React.createElement(Typography, { variant: "h2", color: "secondary" }, header),
                React.createElement(Box, { mt: 2 },
                    React.createElement(Typography, { variant: "body1" }, actionMessage),
                    React.createElement(Box, { mt: 2 },
                        React.createElement("div", { className: classes.preview }, children))))),
        React.createElement(Box, { className: classes.actions, my: 2 },
            React.createElement(Button, { variant: "contained", color: "default", onClick: cancelAction }, negativeMessage),
            React.createElement(Button, { variant: "contained", color: "primary", onClick: confirmAction }, positiveMessage))));
};
export default ActionModal;
//# sourceMappingURL=ActionModal.js.map